;(function() {
/* @ngInject */
function RadioGroupController() {
    let vm = this;
}

angular.module("firmaren")
    .component("radioGroup", {
        templateUrl: "/app/shared/radio-group/radio-group.html",
        controller: RadioGroupController,
        controllerAs: "vm",
        bindings: {
            label: "@",
            name: "@",
            model: "=",
            attrs: "<",
            required: "<"
        }
    });
}());
